import { Injectable } from '@angular/core';
import { UnitActivityProxyService } from '@services/unit-activity-proxy/unit-activity-proxy.service';
import { Observable } from 'rxjs';
import { UnitEditor } from '../../schema/unit-editor';

interface CreateUnitRequest {
  vehicles: string[];
  actors: string[];
  equipments: string[];

  unitName: string;

  mainResource?: string;
  leader?: string;
  communications?: string;
  position?: string;
  unitTypeId?: number;
}

@Injectable()
export class UnitCreationService {
  constructor(private unitActivityProxy: UnitActivityProxyService) {}

  create(editor: UnitEditor): Observable<boolean> {
    const data: CreateUnitRequest = {
      vehicles: editor.vehicles.map(v => v.ObjGuid),
      actors: editor.actors.map(i => i.ObjGuid),
      equipments: editor.communicationEquipments.map(i => i.ObjGuid),
      unitName: editor.name,
      unitTypeId: editor.unitType?.Id,
      mainResource: editor.mainResource?.ObjGuid,
      leader: editor.agent?.ObjGuid,
      communications: editor.communicationEquipment?.ObjGuid,
      position: editor.positionProvider?.ObjGuid
    };

    return this.unitActivityProxy.createUnitActivity(data);
  }
}
